export default "__VITE_ASSET__DBxtP0by__"